import './useContainerFocus.css';
export var containerRoot = '_la3ex60-3-15-1';